import React,{useState,useEffect} from "react";
import {useHistory} from "react-router-dom";
import API from "../../utils/API";
import {toastr} from "react-redux-toastr";
import {Button, Card, CardBody, Container, FormGroup, Label} from "reactstrap";
import {AvForm, AvInput} from "availity-reactstrap-validation";

const TemplateCategoryEdit = (props) => {
    const [category, setCategory] = useState({title:null});
    const [error, setError] = useState(null)

    let history = useHistory();

    const handleChange = (e) => {
        setCategory({ ...category, [e.target.name]: e.target.value })
        setError(null)
    };

    const submit = () => {
        if (props.match.params.id) {
            API.post('/admin/apptemplate/category/'+props.match.params.id,category)
                .then((response) => {
                    toastr.success('Success', 'Category was successfully saved')
                    history.push("/templates/categories")
                })
                .catch(error => {
                    setError('Invalid category data')
                })
        }else {
            API.put('/admin/apptemplate/category',category)
                .then((response) => {
                    toastr.success('Success', 'Category was successfully saved')
                    history.push("/templates/categories")
                })
                .catch(error => {
                    setError('Invalid category data')
                })

        }
    }

    useEffect(()=>{
        if (props.match.params.id) {
            API.get('/admin/apptemplate/category/'+props.match.params.id)
                .then((response) => {
                    setCategory(response.data.data)
                })
        }
    },props.match.params.id)

    return (
        <Container fluid className="p-0">
            <h1 className="h3 mb-3">{props.match.params.id?'Edit':'New'} Template category</h1>
            <Card>
                <CardBody>
                    {error &&
                    <div className="text-center text-danger">{error}</div>
                    }
                    <AvForm onValidSubmit={submit}>
                        <FormGroup>
                            <Label>Title</Label>
                            <AvInput onChange={handleChange} required type="text" name="title" value={category.title} placeholder="Category title" />
                        </FormGroup>
                        <div className="text-center">
                            <Button color="primary">Save</Button>
                        </div>
                    </AvForm>
                </CardBody>
            </Card>
        </Container>
    )
}

export default TemplateCategoryEdit
